import { getChangeRequestActionTypes, sendChangeRequestActionTypes } from './actions';

const initialState = {
  changeRequests: {
    expenseType: {},
    receipt: {},
  },
  error: null,
};

const handleGetChangeRequestRequest = (state) => ({
  ...state,
  loading: true,
});

const handleGetChangeRequestSuccess = (state, changeRequests) => ({
  ...state,
  changeRequests,
  error: null,
});

const handleGetChangeRequestError = (state, action) => ({
  ...state,
  loading: false,
  error: action.error,
});

export default (state = initialState, action) => {
  const handlers = {
    [getChangeRequestActionTypes.request]: handleGetChangeRequestRequest,
    [getChangeRequestActionTypes.success]: handleGetChangeRequestSuccess,
    [getChangeRequestActionTypes.error]: handleGetChangeRequestError,

    [sendChangeRequestActionTypes.request]: handleGetChangeRequestRequest,
    [sendChangeRequestActionTypes.success]: handleGetChangeRequestSuccess,
    [sendChangeRequestActionTypes.error]: handleGetChangeRequestError,

  };
  return handlers[action.type] ? handlers[action.type](state, action) : state;
};
